import React from 'react';

function Button({ children, href, onClick, id }) {
    if (href) {
        return (
            <a href={href} className="apply-button" id={id} onClick={onClick}>
                {children}
            </a>
        );
    }

    return (
        <button onClick={onClick} className="apply-button" id={id}>
            {children}
        </button>
    );
}

export default Button;